require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-ziajmody-two.json") })
        }
      }, "path---insights-ziajmody-two");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-ziajmody-two!./.cache/json/insights-ziajmody-two.json
// module id = 1170
// module chunks = 231608221292675